import InsightsOnboardingCompleted from '~/components/growth_wizard/insights_onboarding/completion_screens/InsightsOnboardingCompleted.vue'

export const COMPLETION_SCREEN_COMPONENTS = {
  insights_onboarding_completed: {
    component: InsightsOnboardingCompleted,
    getProps: (vm) => ({
      organization: vm.organization,
      'completion-screen-data': vm.completionScreenData,
    })
  },
};
